<svelte:options tag="edi-svg-remove" />

<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect opacity="0.2" width="32" height="32" rx="4" fill="#FF6666" />
	<path
		d="M21.5079 15H9.96214C9.43086 15 9 15.4309 9 15.9621V16.9243C9 17.4556 9.43086 17.8864 9.96214 17.8864H21.5079C22.0391 17.8864 22.47 17.4556 22.47 16.9243V15.9621C22.47 15.4309 22.0391 15 21.5079 15Z"
		fill="#FF6666"
	/>
</svg>
